import React from "react";
import { connect } from "react-redux";
import Navigation from "../Components/Navigation";
import NavigationMobile from "../Components/NavigationMobile";
import useIsMobile from "../Hooks/useIsMobile";

const NavigationContainer = (props) => {
  const isMobile = useIsMobile();
  if (isMobile) {
    return <NavigationMobile {...props} />;
  } else {
    return <Navigation {...props} />;
  }
};

const mapStateToProps = (state) => {
  return {
    links: state.navigation.contentLinks,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NavigationContainer);
